import React from 'react';
import GoogleMapReact from 'google-map-react';
import classNames from 'classnames';

import HomeIcon from 'ui-kit/icons/home-icon';

import './style.css';

export const LocationPin = ({ onClick, ...rest }) => {
    const { isFocused } = rest;

    const classes = classNames('mlb-location-pin', { focused: isFocused });
    return (
        <div className={classes} onClick={onClick} role="button" tabIndex={0}>
            <HomeIcon {...rest} />
        </div>
    );
};

const Map = ({ focusedLocation, startingLocation, zoomLevel, locations = [], onLocationClick }) => {
    return (
        <GoogleMapReact
            className="mlb-map"
            bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY }}
            defaultCenter={startingLocation}
            defaultZoom={zoomLevel}
            options={{
                gestureHandling: 'greedy',
                fullscreenControl: false
            }}
        >
            {locations.map(({ address, id, isBiddingOpen, lat, lng }, idx) => (
                <LocationPin
                    key={`mlb-location-pin-${idx}`}
                    lat={lat}
                    lng={lng}
                    text={address}
                    isBiddingOpen={isBiddingOpen}
                    isFocused={focusedLocation && focusedLocation.id === id}
                    onClick={() => onLocationClick({ id })}
                />
            ))}
        </GoogleMapReact>
    );
};
export default Map;
